
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/result",
      function () {
        return require("private-next-pages/search/result/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/result"])
      });
    }
  